import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from 'src/App';
import { AuthProvider } from 'src/auth/context/authProvider';
import { AppProviders } from 'src/components/wagami/WagmiProvider';
import { SettingsProvider } from 'src/components/settings';
import ThemeProvider from 'src/theme';
import { attachCsrf, axiosInstanceNew } from 'src/utils/axios';

attachCsrf(axiosInstanceNew);

const root = ReactDOM.createRoot(document.getElementById('root'));

const host = typeof window !== 'undefined' ? window.location.hostname : '';

const allowWalletReconnect =
  host === 'localhost' ||
  host === '127.0.0.1' ||
  host === 'safiswap.com' ||
  host === 'www.safiswap.com' ||
  host.endsWith('safiswap.netlify.app');

root.render(
  <React.StrictMode>
    <AppProviders reconnectOnMount={allowWalletReconnect}>
      <HelmetProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'dark',
            themeDirection: 'ltr',
            themeContrast: 'default',
            themeLayout: 'vertical',
            themeColorPresets: 'default',
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <AuthProvider>
              <BrowserRouter
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <App />
              </BrowserRouter>
            </AuthProvider>
          </ThemeProvider>
        </SettingsProvider>
      </HelmetProvider>
    </AppProviders>
  </React.StrictMode>
);
